import { useCallback, useEffect, useState } from 'react';
import { 
  Page, 
  Card, 
  Icon, 
  Avatar,
  Filters,
  ResourceList,
  ResourceItem,
  TextField,
} from '@shopify/polaris';
import {
  NotificationMajor,
  FilterMajor,
  EditMinor,
  MobileVerticalDotsMajor,
  AttachmentMajor,
  SendMajor,
  CancelSmallMinor
} from '@shopify/polaris-icons';
import { usersChatList, usersChatFilterTags, usersChats } from '../../constants/chat-constants';
import './chat.scss';

function Chat(props: any) {

  const [queryValue, setQueryValue] = useState('');
  const [showUserInfoPanel, setShowUserInfoPanel] = useState(false);
  const [currentUser, setCurrentUser] = useState(usersChatList[0]);

  const handleFiltersQueryChange = (value: string) => {
    setQueryValue(value)
  }
  
  const handleQueryValueRemove = () => {
    setQueryValue('')
  }

  const handleOpenChatUser = (id: string) => {
    console.log("Open chat of user Id => ", id)
    let selectedUser = usersChatList.filter((usrList) => { return usrList.id === id })
    setCurrentUser(selectedUser[0]);
  }

  const handleOpenUserInfoDetails = () => {
    console.log("Open chat of user Id => ");
    setShowUserInfoPanel(true);
  }

  const handleCloseUserInfoDetails = () => {
    setShowUserInfoPanel(false);
  }

  return (
    <Page fullWidth>
      <div className='storeContainer'>
        <div className="storeDetailsContainer">
          <Card sectioned>
            <div className="storeDetails">
              <div className="storeDetailsLeft">
                <Avatar customer name="Farrah" />
                <span className="storeName">Store Name</span>
              </div>
              <div className="storeDetailsRight">
                <Icon
                  source={NotificationMajor}
                  color="base"
                />
              </div>
            </div>
          </Card>
          <div className='filterContainer'>
            <Filters
              queryValue={queryValue}
              filters={[]}
              appliedFilters={[]}
              onQueryChange={(val) => {handleFiltersQueryChange(val)}}
              onQueryClear={handleQueryValueRemove}
              onClearAll={() => {}}
            />
            <Icon
              source={FilterMajor}
              color="base"
            />
          </div>
          <div className='chatTagsContainer'>
            {usersChatFilterTags.map((ucft: any, index) => {
              return (
                <div className='chatTag'>
                  <span>{ucft.label}</span>
                  {ucft.count > 0 && <span className='boldText whiteBg'>{ucft.count}</span>}
                </div>
              )
            })}
          </div>
          <div>
            <ResourceList
              items={ usersChatList }
              renderItem={(item) => {
                const { id, name, picture, lastMesssage, lastMesssageTime } = item;
                const media = <Avatar customer size="medium" name={name} source={picture} />;

                return (
                  <ResourceItem
                    id={id}
                    media={media}
                    accessibilityLabel={`View details for ${name}`}
                    onClick={() => handleOpenChatUser(id)}
                  >
                    <div className='userListLeft'>
                      <span className="boldText">{name}</span>
                      <div>{lastMesssage}</div>
                    </div>
                    <div className='userListRight'>
                      {lastMesssageTime}
                    </div>
                  </ResourceItem>
                );
              }}
            />
          </div>
        </div>

        <div className={showUserInfoPanel ? `storeUserChatContainer wid40` : `storeUserChatContainer wid60`}>
          <Card sectioned>
            <div className="userChatDetails">
              <div className="userChatDetailsLeft">
                <Avatar customer name="Farrah" />
                <div className='userInfo'>
                  <span className="userName">{currentUser.name}</span>
                  <div className="userChatTag">
                    <label>Add status or note about this chat</label>
                    <Icon
                      source={EditMinor}
                      color="base"
                    />
                  </div>
                </div>                
              </div>
              <div className="userChatDetailsRight" onClick={handleOpenUserInfoDetails}>
                <Icon
                  source={MobileVerticalDotsMajor}
                  color="base"
                />
              </div>
            </div>
          </Card>

          <div className='messageDate'>
            December 29
          </div>
          
          {usersChats.messages.map((ucMessage: any, index: any) => {
            return (
              <div className={ucMessage.userMessage ? 'incomingMessage' : 'outgoingMessage'} key={index}>
                <Avatar customer name="Farrah" />
                <div className='userMessageText'>
                  <span className='userMessageTextContent'>{ucMessage.lastMesssage}</span>
                  <span className='userMessageTextTime'>{ucMessage.lastMesssageTime}</span>
                </div>
              </div>
            )
          })}          
          
          {/* <div className='incomingMessage'>
            <Avatar customer name="Farrah" />
            <div className='userMessageText'>
              <span className='userMessageTextContent'>Hello</span>
              <span className='userMessageTextTime'>06:40 pm</span>
            </div>
          </div>

          <div className='outgoingMessage'>
            <Avatar customer name="Farrah" />
            <div className='userMessageText'>
              <span className='userMessageTextContent'>Hello</span>
              <span className='userMessageTextTime'>06:40 pm</span>
            </div>
          </div> */}

          <div className='textInputContainer'>
            <div className='userInputBox'>
              <div className='w90'>
                <TextField
                  label=""
                  value={''}
                  onChange={() => {}}
                />
              </div>
              <Icon
                source={AttachmentMajor}
                color="base"
              />
            </div>
            <div className='userInputSendButton'>
              <Icon
                source={SendMajor}
                color="base"
              />
            </div>
          </div>

        </div>

        {showUserInfoPanel &&
          <div className="storeUserDetailsContainer">
          <div className="userDetailsInfoContainer">
            <div className="userDetailsInfo">
              <Avatar customer name="Farrah" />
              <span className="userName">Ankit Chandana</span>
              <label>+91-9423276337</label>
            </div>
            <div className='closeIcon' onClick={handleCloseUserInfoDetails}>
              <Icon source={CancelSmallMinor} color="base" />
            </div>
          </div>
          </div> 
        }       

      </div>
    </Page>
  );
}

export default Chat;
